// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"863":"3e4c344f","3411":"3e4c344f","3613":"3e4c344f","7742":"71dcd781","9763":"3e4c344f"}[chunkId] + ".chunk.css";
};